export const msalConfig = {
  auth: {
    clientId: "96ff64bc-0308-4221-b4b3-5500cf141520",
    authority:
      "https://login.microsoftonline.com/aa91303b-4f61-4e33-adb3-b0a80b0abe32",
    redirectUri: "https://caldenflowaudit.caldenoil.com/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
